import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=3b60409e&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=js&"
export * from "./AddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=3b60409e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b60409e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b60409e')) {
      api.createRecord('3b60409e', component.options)
    } else {
      api.reload('3b60409e', component.options)
    }
    module.hot.accept("./AddDialog.vue?vue&type=template&id=3b60409e&scoped=true&", function () {
      api.rerender('3b60409e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classAdmin/components/AddDialog.vue"
export default component.exports